// import Swiper from 'swiper';

//   //initialize swiper when document ready
//   const swiper = new Swiper('.swiper-container', {
//     spaceBetween: 30,
//     //effect: 'fade',
//     autoplay: {
//         delay: 3000,
//     },
//     pagination: {
//         el: '.swiper-pagination',
//         clickable: true,
//     },
//     navigation: {
//         nextEl: '.swiper-button-next',
//         prevEl: '.swiper-button-prev',
//     },
//   });
//   export default swiper;



// WEBPACK FOOTER //
// ./scripts/util/custom.js